import {
  call, put, select, takeEvery,
} from 'redux-saga/effects';
import callAdapter from '@/utils/sagaHelper';
import findResult, { createOrderByParams, wildcardFilter } from '@/utils/resultsHelper';
import selectors from '@/selectors';
import DictionariesService from '@/datasets/dictionaries/service';
import DatasetSettingService from '@/datasets/settings/service';
import CataloguesService from '@/datasets/catalogue/service';
import DatasetStatusService from '@/datasets/status/service';
import DatasetNamespaceService from '@/datasets/namespaces/service';
import DatasetsService from '@/datasets/service';
import { showRequestSourceError } from '../../actions';
import {
  catalogueToRequest,
  datasetSettingsToRequest,
  dictionariesToRequest,
  datasetToRequestError,
  showRequestDatasets,
} from '../actions';
import actions from '../constants';

export function* dictionaries({ category, code, datasetCode }) {
  const { response, error } = yield call(callAdapter, DictionariesService.datasetDictionaries(
    null,
    datasetCode,
    false,
    1,
    null,
  ));
  if (error) {
    yield put(showRequestSourceError(category, code, error));
  } else {
    yield put(dictionariesToRequest(category, code, response.items));
  }
}

function* datasetStatus(category, code, datasetCode, settings, namespaces) {
  const { response, error } = yield call(callAdapter, DatasetStatusService.status(datasetCode));

  if (error) {
    yield put(showRequestSourceError(category, code, error));
  } else {
    const workflows = yield select(selectors.workflows);
    const workflow = findResult(workflows, category, settings.workflow_key);
    yield put(datasetSettingsToRequest(category, code, settings, namespaces, response, workflow));
  }
}

function* datasetNamespaces(category, code, datasetCode, settings) {
  const { response, error } = yield call(callAdapter, DatasetNamespaceService.namespaces(datasetCode));

  if (error) {
    yield put(showRequestSourceError(category, code, error));
  } else {
    yield call(datasetStatus, category, code, datasetCode, settings, response.items);
  }
}

export function* datasetSettings({ category, code, datasetCode }) {
  const { response, error } = yield call(callAdapter, DatasetSettingService.settings(datasetCode));
  if (error) {
    yield put(showRequestSourceError(category, code, error));
  } else {
    yield call(datasetNamespaces, category, code, datasetCode, response);
  }
}

export function* datasetCatalogue({ category, code, datasetCode }) {
  const { response, error } = yield call(callAdapter, CataloguesService.catalogue(datasetCode));
  if (error) {
    yield put(showRequestSourceError(category, code, error));
  } else {
    yield put(catalogueToRequest(category, code, response));
  }
}

export function* datasets(action) {
  const items = yield select(selectors.requests);
  const item = findResult(items, action.category, action.code);
  const {
    filter, pageSize, currentPage, privateFlag, internalFlag, publicFlag, dataModelCode, orderBy,
  } = item.steps.datasets;
  const page = action.page || currentPage;
  const size = action.pageSize || pageSize;
  const includePrivate = action.privateFlag || privateFlag;
  const includeInternal = action.internalFlag || internalFlag;
  const includePublic = action.publicFlag || publicFlag;
  const includeDataModel = action.dataModelCode || dataModelCode;
  const orderByParams = createOrderByParams(orderBy);
  const { response, error } = yield call(callAdapter, DatasetsService.datasets(
    wildcardFilter(filter),
    includePrivate,
    includeInternal,
    includePublic,
    includeDataModel,
    page,
    size,
    true,
    false,
    orderByParams,
  ));

  if (error) {
    yield put(datasetToRequestError(action.category, action.code, error));
  } else {
    yield put(showRequestDatasets(
      action.category,
      action.code,
      action.append,
      size,
      response.items,
      response.paging.total,
      response.paging.pages,
      response.paging.page,
    ));
  }
}

export default function* requestDatasetsApi() {
  yield takeEvery(actions.FETCH_REQUEST_CATALOGUE, datasetCatalogue);
  yield takeEvery(actions.FETCH_REQUEST_DICTIONARIES, dictionaries);
  yield takeEvery(actions.FETCH_REQUEST_DATASET_SETTINGS, datasetSettings);
  yield takeEvery([actions.FETCH_REQUEST_DATASETS, actions.UPDATE_REQUEST_DATASETS_FLAGS], datasets);
}
